import { PHONE, GOOGLE_BUSINESS_URL } from "@/constants/contact";

const navLinks = [
  { id: "home", label: "Home" },
  { id: "about", label: "About" },
  { id: "services", label: "Services" },
  { id: "contact", label: "Contact" },
];

export default function Footer() {
  const go = (id) => {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <footer
      data-testid="footer"
      className="relative pt-12 pb-8 px-6 text-white"
      style={{ background: "var(--color-accent)" }}
    >
      <div className="max-w-7xl mx-auto">
        <div className="grid md:grid-cols-3 gap-8 items-center">
          <p
            className="font-body text-sm md:text-base text-center md:text-left"
            data-testid="footer-copyright"
          >
            © 2026 Dr. Fiza Hasny · Psychologist, Jaipur
          </p>

          <ul className="flex flex-wrap justify-center gap-6">
            {navLinks.map((l) => (
              <li key={l.id}>
                <button
                  onClick={() => go(l.id)}
                  className="font-body text-sm hover:underline"
                  data-testid={`footer-link-${l.id}`}
                >
                  {l.label}
                </button>
              </li>
            ))}
          </ul>

          <div className="flex justify-center md:justify-end gap-3">
            <a
              href={`https://wa.me/${PHONE}`}
              target="_blank"
              rel="noreferrer"
              data-testid="footer-whatsapp"
              className="w-10 h-10 rounded-full flex items-center justify-center bg-white/15 hover:bg-white/25 transition-colors"
              aria-label="WhatsApp"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="18"
                height="18"
                viewBox="0 0 24 24"
                fill="#fff"
              >
                <path d="M.057 24l1.687-6.163a11.867 11.867 0 01-1.587-5.946C.16 5.335 5.495 0 12.05 0a11.817 11.817 0 018.413 3.488 11.824 11.824 0 013.48 8.414c-.003 6.557-5.338 11.892-11.893 11.892a11.9 11.9 0 01-5.688-1.448L.057 24zm6.597-3.807c1.676.995 3.276 1.591 5.392 1.592 5.448 0 9.886-4.434 9.889-9.885.002-5.462-4.415-9.89-9.881-9.892-5.452 0-9.887 4.434-9.889 9.884a9.86 9.86 0 001.683 5.526l-.999 3.648 3.805-.873z"></path>
              </svg>
            </a>
            <a
              href={GOOGLE_BUSINESS_URL}
              target="_blank"
              rel="noreferrer"
              data-testid="footer-google"
              className="w-10 h-10 rounded-full flex items-center justify-center bg-white/15 hover:bg-white/25 transition-colors font-display font-bold text-sm"
              aria-label="Google Business Profile"
            >
              G
            </a>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-white/20 text-center">
          <p
            className="font-body italic text-sm opacity-90"
            data-testid="footer-tagline"
          >
            Designed with 💚 for Mental Wellness
          </p>
        </div>
      </div>
    </footer>
  );
}
